import { ref } from "vue";

/**
 * 画面ロジックを扱う composable。
 */
export const useSalesSummaryUiState = () => {
  const errdialog = ref(false); //エラーダイアログ
  const errMessage = ref(""); //エラーメッセージ
  const panel = ref<number[]>([0]);
  const overlay = ref(false); //Loading
  const downloadingDialog = ref(false);
  const listLoading = ref(false);
  // 配達依頼一覧 絞込み後の全データ数
  const listDataTotalCount = ref(0);

  // 一覧データ表示フラグ
  const dispAllShopByDaylist = ref(false);
  const dispAllShopByShoplist = ref(false);
  const dispEachShopByDaylist = ref(false);

  return {
    errdialog,
    errMessage,
    panel,
    overlay,
    downloadingDialog,
    listLoading,
    listDataTotalCount,
    dispAllShopByDaylist,
    dispAllShopByShoplist,
    dispEachShopByDaylist,
  };
};
